import './ChooseOnMapTooltip.scss';

import {EnvironmentOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import React from 'react';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import * as modalTypes from '../../consts/modals/modalTypes';
import useIsMobileViewport from '../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import {hideModalAction, showMapModalAction} from '../../state/ducks/modal';
import {dispatch} from '../../state/store';
import IconLocation from '../Icons/IconLocation';

const ChooseOnMapTooltip = ({form}) => {
    const isMobile = useIsMobileViewport();
    const localizedStrings = getLocalizedStrings();
    const showMapModal = () => {
        dispatch(
            showMapModalAction({
                onCancel: () => dispatch(hideModalAction(modalTypes.MAP_MODAL_TYPE)),
                form,
            })
        );
    };

    const handleTooltipClick = () => {
        showMapModal();
    };

    if (isMobile) {
        return (
            <button
                type='button'
                className='choose-on-map-button'
                onClick={showMapModal}
                aria-label={localizedStrings[localizationKeys.BUILDING_FORM_CHOOSE_ON_MAP]}
                aria-haspopup='dialog'
            >
                <EnvironmentOutlined aria-hidden />
            </button>
        );
    }

    const tooltipTitle = 'Вибрати на карті';

    return (
        <Tooltip onClick={handleTooltipClick} className='cursor-pointer -mr-2 h-10 w-10 px-1 py-1' title={tooltipTitle}>
            <IconLocation color={'red'} width={15} height={20} />
        </Tooltip>
    );
};

export default ChooseOnMapTooltip;
